const getCartSections = () => {
  const sections = ['cart-button'];
  const mainCartSection = document.querySelector('.shopify-section--main-cart');

  if (mainCartSection?.id) {
    sections.push(mainCartSection.id.replace(/^shopify-section-/, ''));
  }

  const cartDrawer = document.querySelector('cart-drawer');
  const drawerSection = cartDrawer?.closest('.shopify-section');

  if (drawerSection?.id) {
    sections.push(drawerSection.id.replace(/^shopify-section-/, ''));
  }

  return [...new Set(sections)];
};

const setButtonLoading = (button, loading) => {
  button.classList.toggle('is-loading', loading);
  button.disabled = loading;
};

const dispatchCartEvent = (button, type, detail) => {
  button.dispatchEvent(new CustomEvent(type, { bubbles: true, detail }));
};

const getQuantityFromRow = (row) => {
  const input = row?.querySelector('.quantity-selector__input');
  const quantity = Number.parseInt(input?.value ?? '1', 10);

  if (!Number.isFinite(quantity) || quantity < 1) {
    return 1;
  }

  return quantity;
};

document.addEventListener('click', async (event) => {
  const button = event.target.closest('[data-product-card-cart-add]');

  if (!button || button.disabled) {
    return;
  }

  const variantId = button.getAttribute('variant-id');

  if (!variantId) {
    return;
  }

  event.preventDefault();

  const row = button.closest('.product-card__cart-row');
  const quantity = getQuantityFromRow(row);
  const sections = getCartSections();
  const payload = {
    id: variantId,
    quantity,
    sections: sections.join(','),
    sections_url: `${window.location.pathname}${window.location.search}`,
  };

  dispatchCartEvent(button, 'cart:updating', { type: 'add', request: payload });
  setButtonLoading(button, true);

  try {
    const response = await fetch(window.routes.cart_add_url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
      body: JSON.stringify(payload),
    });

    const data = await response.json();

    if (!response.ok) {
      throw new Error(data.description || 'Cart add failed');
    }

    dispatchCartEvent(button, 'cart:updated', {
      type: 'add',
      request: payload,
      response: data,
      error: null,
    });
  } catch (error) {
    dispatchCartEvent(button, 'cart:updated', {
      type: 'add',
      request: payload,
      response: null,
      error: error.message,
    });
  } finally {
    setButtonLoading(button, false);
  }
});
